import { render, staticRenderFns } from "./UserDetailViewer.vue?vue&type=template&id=20e771a2&scoped=true&"
import script from "./UserDetailViewer.vue?vue&type=script&lang=ts&"
export * from "./UserDetailViewer.vue?vue&type=script&lang=ts&"
import style0 from "./UserDetailViewer.vue?vue&type=style&index=0&id=20e771a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e771a2",
  null
  
)

export default component.exports